<template>
  <div class="charisma-location-receipts">
    <general-top-bar :title="$t('reports.charismaLocationReceipt')"></general-top-bar>
    <div class="card">
      <div class="card-content">
        <div class="table-wrapper">
          <el-table
            v-loading="loading"
            :data="locationReceipts"
            :empty-text="$t('reports.noDataAvailable')"
            class="report-sales"
            style="width: 100%">
            <el-table-column class-name="centered-cell" prop="id" min-width="80" label="ID"></el-table-column>
            <el-table-column class-name="centered-cell" prop="name" min-width="120" :label="$t('reports.location')"></el-table-column>
            <el-table-column class-name="centered-cell" prop="administration" min-width="160" :label="$t('charisma.categoryAdministration')">
              <template slot-scope="scope">
                {{ scope.row.administration.name || '-' }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" prop="partner_code" min-width="140" :label="$t('reports.partnerCode')">
              <template slot-scope="scope">
                {{ scope.row.partner_code || '-' }}
              </template>
            </el-table-column>
            <el-table-column
              class-name="centered-cell"
              prop="actions"
              min-width="100"
              :label="$t('marketingCampaigns.actions')">
              <template slot-scope="scope">
                <div class="display-flex" style="align-items: center; justify-content: center;">
                  <a
                    class="btn btn-icon btn-purple"
                    :title="$t('marketingCampaigns.open')"
                    @click.prevent="goToLocationReceipt(scope.row)">
                    <i class="ti-angle-right"></i>
                  </a>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert2'
import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'

export default {
  name: 'CharismaLocationReceipt',
  components: {
    GeneralTopBar
  },
  props: {
    isCharismaLocationReceiptReport: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      locationReceipts: [],
      hasLoadedOnce: false
    }
  },
  watch: {
    isCharismaLocationReceiptReport: {
      immediate: true,
      handler (val) {
        if (val && (!this.hasLoadedOnce || !this.locationReceipts.length)) {
          this.fetchLocationReceipts()
        }
      }
    }
  },
  methods: {
    fetchLocationReceipts () {
      if (!this.isCharismaLocationReceiptReport) {
        return
      }
      this.loading = true
      const payload = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/reports/v2/charisma/location-receipts', 'GET', payload, response => {
        if (response && response.status) {
          this.locationReceipts = Array.isArray(response.data) ? response.data : []
          this.hasLoadedOnce = true
        } else {
          this.locationReceipts = []
          swal(
            '',
            response && response.errors && response.errors.id ? response.errors.id : this.$t('validations.wentWrong'),
            'error'
          )
        }
        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    goToLocationReceipt (row) {
      if (!row || !row.id) {
        return
      }
      const query = Object.assign({}, this.$route.query, {
        tab: 'charismaLocationReceipt',
        locationName: row.name || '',
        partnerCode: row.partner_code || '',
        administrationName: (row.administration && row.administration.name) ? row.administration.name : ''
      })
      this.$router.push({ path: `/reports/charisma/location-receipts/${row.id}`, query })
    }
  }
}
</script>

<style scoped>
.charisma-location-receipts .card {
  margin-top: 15px;
}
.charisma-location-receipts .table-wrapper {
  width: 100%;
  overflow-x: auto;
}
</style>




// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Versions/2/CharismaLocationReceipt.vue